var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wallet case-history box-battle-history" },
    [
      _c("div", { staticClass: "fairness-verification-box" }, [
        _c("div", { staticClass: "title" }, [_vm._v("公平性验证")]),
        _c("div", { staticClass: "description" }, [
          _vm._v(
            " 我们的盒战系统采用公平可验证的随机数生成算法。客户端种子是由您掌控的随机因素，通过它可以配合后端验证每一局结果是否可信。 "
          ),
        ]),
        _c("div", { staticClass: "input-group" }, [
          _c("div", { staticClass: "input-item" }, [
            _c("label", [_vm._v("客户端种子 (Client Seed)")]),
            _c(
              "div",
              { staticClass: "client-seed-wrapper" },
              [
                _c("Input", {
                  attrs: { placeholder: "请输入客户端种子" },
                  model: {
                    value: _vm.clientSeed,
                    callback: function ($$v) {
                      _vm.clientSeed = $$v
                    },
                    expression: "clientSeed",
                  },
                }),
                _c(
                  "Button",
                  {
                    staticClass: "save-btn",
                    attrs: { type: "primary", loading: _vm.savingSeed },
                    on: { click: _vm.saveClientSeed },
                  },
                  [_vm._v("保存")]
                ),
                _c(
                  "Button",
                  {
                    staticClass: "save-btn",
                    attrs: { type: "info" },
                    on: { click: _vm.openThirdPartyVerify },
                  },
                  [_vm._v("跳转第三方网站验证")]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "wallet_detail_box" }, [
        _c("table", { staticClass: "list" }, [
          _vm._m(0),
          _c(
            "tbody",
            [
              _vm._l(_vm.historyData.data.list, function (room, index) {
                return [
                  _c(
                    "tr",
                    {
                      key: room.rowKey,
                      staticClass: "room-row",
                      class: { active: _vm.isRoomExpanded(room) },
                    },
                    [
                      _c(
                        "td",
                        [
                          _c(
                            "Button",
                            {
                              staticClass: "expand-btn",
                              attrs: {
                                type: "text",
                                icon: _vm.isRoomExpanded(room)
                                  ? "ios-arrow-up"
                                  : "ios-arrow-down",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.toggleRoom(room)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.isRoomExpanded(room) ? "收起" : "展开"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("td", [
                        _c("span", { staticClass: "room-id" }, [
                          _vm._v(_vm._s(room.battleRoomId)),
                        ]),
                      ]),
                      _c("td", [
                        _c("span", { staticClass: "player-count" }, [
                          _vm._v(_vm._s(room.players.length) + "人"),
                        ]),
                      ]),
                      _c("td", [
                        _c(
                          "div",
                          { staticClass: "case-list" },
                          [
                            _vm._l(room.cases, function (caseItem, caseIndex) {
                              return _c(
                                "div",
                                {
                                  key:
                                    room.rowKey +
                                    "-case-" +
                                    caseIndex +
                                    "-" +
                                    caseItem.id,
                                  staticClass: "case-chip",
                                },
                                [
                                  caseItem.casePic
                                    ? _c("img", {
                                        attrs: {
                                          src: caseItem.casePic,
                                          alt: caseItem.caseName || "箱子",
                                        },
                                      })
                                    : _vm._e(),
                                  _c("div", { staticClass: "case-info" }, [
                                    _c("span", { staticClass: "case-name" }, [
                                      _vm._v(_vm._s(caseItem.caseName || "-")),
                                    ]),
                                  ]),
                                ]
                              )
                            }),
                            room.cases.length === 0
                              ? _c("span", [_vm._v("-")])
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]),
                      _c("td", [
                        _c(
                          "div",
                          { staticClass: "server-seed-cell" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "server-seed-text",
                                attrs: { title: room.serverSeed || "" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getServerSeedPreview(room.serverSeed)
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            room.serverSeed
                              ? _c(
                                  "Tooltip",
                                  {
                                    attrs: {
                                      content: "复制服务器种子",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c(
                                      "Button",
                                      {
                                        staticClass: "seed-copy-btn",
                                        attrs: {
                                          icon: "md-copy",
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.copyValue(
                                              room.serverSeed,
                                              "已复制服务器种子"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("复制")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _c("td", [
                        _c("span", { staticClass: "time" }, [
                          _vm._v(_vm._s(room.createTime)),
                        ]),
                      ]),
                    ]
                  ),
                  _vm.isRoomExpanded(room)
                    ? _c(
                        "tr",
                        {
                          key: room.rowKey + "-detail",
                          staticClass: "room-detail-row",
                        },
                        [
                          _c("td", { attrs: { colspan: "6" } }, [
                            _c(
                              "div",
                              { staticClass: "room-detail" },
                              [
                                _vm._l(
                                  room.players,
                                  function (player, playerIndex) {
                                    return _c(
                                      "div",
                                      {
                                        key:
                                          room.rowKey +
                                          "-player-" +
                                          playerIndex +
                                          "-" +
                                          player.memberId,
                                        staticClass: "player-block",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "player-head" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "player-main" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "player-avatar",
                                                  },
                                                  [
                                                    player.avatar
                                                      ? _c("img", {
                                                          attrs: {
                                                            src: player.avatar,
                                                            alt:
                                                              player.name ||
                                                              "玩家",
                                                          },
                                                        })
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getPlayerInitial(
                                                                player.name
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "player-info",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "player-name",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            player.name || "-"
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "player-sub",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "ID: " +
                                                            _vm._s(
                                                              _vm.displayValue(
                                                                player.memberId
                                                              )
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "player-tags" },
                                              [
                                                player.isCurrentUser
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "player-tag current",
                                                      },
                                                      [_vm._v("当前用户")]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "table",
                                          { staticClass: "detail-table" },
                                          [
                                            _vm._m(1, true),
                                            _c(
                                              "tbody",
                                              _vm._l(
                                                player.details,
                                                function (detail, detailIndex) {
                                                  return _c(
                                                    "tr",
                                                    {
                                                      key:
                                                        room.rowKey +
                                                        "-player-" +
                                                        playerIndex +
                                                        "-detail-" +
                                                        detailIndex +
                                                        "-" +
                                                        detail.id,
                                                    },
                                                    [
                                                      _c("td", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "count-badge",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.displayValue(
                                                                  detail.battleCount
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]),
                                                      _c("td", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "name-cell",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "main-name",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    detail.caseBattleName ||
                                                                      "-"
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "sub-name",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "ID: " +
                                                                    _vm._s(
                                                                      _vm.displayValue(
                                                                        detail.caseBattleId
                                                                      )
                                                                    )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]),
                                                      _c("td", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "name-cell",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "main-name",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    detail.caseItemName ||
                                                                      "-"
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]),
                                                      _c("td", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "seat-cell",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "seat-value",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.displayValue(
                                                                      detail.fairNonce
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]),
                                                      _c("td", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "roll-value",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.displayValue(
                                                                  detail.fairMaxRoll
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]),
                                                      _c("td", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "roll-value",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.displayValue(
                                                                  detail.fairRoll
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]),
                                                      _c("td", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "hash-text",
                                                            attrs: {
                                                              title:
                                                                detail.fairClientSeed ||
                                                                "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.displayValue(
                                                                    detail.fairClientSeed
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                        player.details.length === 0
                                          ? _c(
                                              "div",
                                              { staticClass: "detail-empty" },
                                              [_vm._v("暂无轮次结果")]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }
                                ),
                                room.players.length === 0
                                  ? _c("div", { staticClass: "detail-empty" }, [
                                      _vm._v("暂无玩家记录"),
                                    ])
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
        ]),
        _vm.historyData.data.list.length === 0
          ? _c("div", { staticClass: "none-item" }, [
              _c("div", [_vm._v("暂无盒战记录")]),
              _c("img", {
                attrs: {
                  src: require("@/assets/images/none-item.svg"),
                  alt: "",
                },
              }),
            ])
          : _vm._e(),
      ]),
      _c("Page", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.historyData.data.total > _vm.historyData.size,
            expression: "historyData.data.total > historyData.size",
          },
        ],
        attrs: {
          current: _vm.historyData.current,
          total: _vm.historyData.data.total,
          "page-size": _vm.historyData.size,
          "class-name": "page",
        },
        on: {
          "update:current": function ($event) {
            return _vm.$set(_vm.historyData, "current", $event)
          },
          "on-change": _vm.pageF,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("操作")]),
        _c("th", [_vm._v("房间号")]),
        _c("th", [_vm._v("玩家")]),
        _c("th", [_vm._v("箱子")]),
        _c("th", [_vm._v("服务器种子")]),
        _c("th", [_vm._v("创建时间")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("轮次")]),
        _c("th", [_vm._v("箱子")]),
        _c("th", [_vm._v("奖品")]),
        _c("th", [_vm._v("座位号")]),
        _c("th", [_vm._v("最大Roll值")]),
        _c("th", [_vm._v("Roll值")]),
        _c("th", [_vm._v("客户端种子")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }